import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef } from 'react';
import { Popover as MuiPopover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import colors from '../../foundations/colors.module.scss';
import { BottomSheetContentLayout } from '../BottomSheet';
import { useDevice } from '../Device';
import { baseMenuPaperStyles } from '../Menu';
import { useOverlayContext } from '../OverlayContext';
const useStyles = makeStyles({
    paper: _object_spread_props(_object_spread({
        background: colors.dark50
    }, baseMenuPaperStyles), {
        margin: 0
    })
});
function MobilePopover(param) {
    let { open, children, onClose, bottomSheetHeader } = param;
    const { pushBottomSheetPage, popBottomSheetPage } = useOverlayContext();
    const hasPushedPageRef = useRef(false);
    useEffect(()=>{
        if (open) {
            hasPushedPageRef.current = true;
            pushBottomSheetPage({
                content: /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
                    fillHeight: true,
                    header: bottomSheetHeader,
                    children: children
                }),
                paddingBottom: 0,
                onClose: ()=>{
                    onClose === null || onClose === void 0 ? void 0 : onClose({}, 'backdropClick');
                }
            });
        } else if (hasPushedPageRef.current) {
            hasPushedPageRef.current = false;
            popBottomSheetPage();
        }
    }, [
        open
    ]); // eslint-disable-line react-hooks-static-deps/exhaustive-deps
    return null;
}
/** A customized popover based on Material-UI's Popover component. */ export function Popover(props) {
    var _props_anchorOrigin, _additionalProps_anchorOrigin;
    const { classes, testId, bottomSheetHeader } = props, restProps = _object_without_properties(props, [
        "classes",
        "testId",
        "bottomSheetHeader"
    ]);
    const overrides = useStyles();
    const { isMobileDevice } = useDevice();
    const actualClasses = useMemo(()=>{
        return _object_spread_props(_object_spread({}, classes || {}), {
            paper: cn(overrides.paper, classes === null || classes === void 0 ? void 0 : classes.paper)
        });
    }, [
        classes,
        overrides
    ]);
    const additionalProps = {};
    if (!(props === null || props === void 0 ? void 0 : (_props_anchorOrigin = props.anchorOrigin) === null || _props_anchorOrigin === void 0 ? void 0 : _props_anchorOrigin.horizontal)) {
        additionalProps.anchorOrigin = {
            vertical: 'bottom',
            horizontal: 'left'
        };
    }
    if ((additionalProps === null || additionalProps === void 0 ? void 0 : (_additionalProps_anchorOrigin = additionalProps.anchorOrigin) === null || _additionalProps_anchorOrigin === void 0 ? void 0 : _additionalProps_anchorOrigin.horizontal) === 'left') {
        additionalProps.transformOrigin = {
            vertical: -8,
            horizontal: 'left'
        };
    }
    return isMobileDevice ? /*#__PURE__*/ _jsx(MobilePopover, _object_spread({
        bottomSheetHeader: bottomSheetHeader
    }, props)) : /*#__PURE__*/ _jsx(MuiPopover, _object_spread(_object_spread_props(_object_spread({}, restProps), {
        "data-testid": testId,
        classes: actualClasses
    }), additionalProps));
}
